export const EVENT_ADD_TO_CART = 'EVENT_ADD_TO_CART';
export const EVENT_NEED_CLEAR_CART = 'EVENT_NEED_CLEAR_CART';
export const EVENT_DETAIL_OFFER_PAGE = 'EVENT_DETAIL_OFFER_PAGE';

export const EVENT_DELIVERY_CHANGE = 'EVENT_DELIVERY_CHANGE';
export const EVENT_HANDLE_GLOBAL_ERROR = 'EVENT_HANDLE_GLOBAL_ERROR';

export const EVENT_LAB_SET_NAME_FROM_ORDER = 'EVENT_LAB_SET_NAME_FROM_ORDER';
export const EVENT_LAB_SKIP_CREATE = 'EVENT_LAB_SKIP_CREATE';

export const EVENT_LAB_FORM_OPEN = 'EVENT_LAB_FORM_OPEN';
export const EVENT_FILTER_APPLIED = 'EVENT_FILTER_APPLIED';
export const EVENT_START_LOAD_CATALOG = 'EVENT_START_LOAD_CATALOG';
export const EVENT_FINISH_LOAD_CATALOG = 'EVENT_FINISH_LOAD_CATALOG';
export const EVENT_LAB_SLIDER_INIT = 'eventLabSliderInit';

export const EVENT_ORDER_CHANGE = 'EVENT_ORDER_CHANGE';
export const EVENT_ORDER_BONUSES = 'EVENT_ORDER_BONUSES';

export const EVENT_ADD_NEW_PERSON_COMPANY = 'EVENT_ADD_NEW_PERSON_COMPANY';

export const EVENT_UNION_COMPANY_MODAL = 'EVENT_UNION_COMPANY_MODAL';
